import { Container } from '@pixi/react'
import { gameConfig } from '../../config'
import { Container as PixiContainer } from 'pixi.js'
import { memo, useEffect, useRef } from 'react'
import { godziDropService } from '../../domain/godzi'

export const GodziDropWrapper = memo(() => {
  const godziWrapperRef = useRef<PixiContainer>()

  useEffect(() => {
    godziDropService.initGodziDropWrapper(godziWrapperRef.current as PixiContainer)
  }, [])

  return (
    <Container
      eventMode="static"
      name="godziDropWrapper"
      x={gameConfig.resolution.width / 2}
      y={gameConfig.resolution.height / 2}
      ref={(el: PixiContainer | null) => {
        godziWrapperRef.current = el as PixiContainer
      }}
      scale={1}
    >
    </Container>
  )
})
